export enum CashTransferType {
  SENT = 1,
  RECEIVED = 2,
}
